function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  stroke: "#8084BC",
  strokeWidth: 3.2431,
  strokeMiterlimit: 10,
  cx: 87.9,
  cy: 87.9,
  r: 83.6
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  stroke: "#8084BC",
  strokeWidth: 2.7601,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "0,4.9888",
  cx: 87.9,
  cy: 87.9,
  r: 77.8
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#8084BC",
  d: "M73.2,83.9c14.7,0,26.7-9.7,26.7-21.5s-12-21.5-26.7-21.5c-14.7,0-26.7,9.7-26.7,21.5S58.5,83.9,73.2,83.9z  M73.2,43.9c13.1,0,23.7,8.3,23.7,18.5S86.3,80.9,73.2,80.9c-13.1,0-23.7-8.3-23.7-18.5S60.2,43.9,73.2,43.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8084BC",
  d: "M90.6,82.1c0,3.3,3.1,6,6.9,6s6.9-2.7,6.9-6c0-3.3-3.1-6-6.9-6S90.6,78.8,90.6,82.1z M101.4,82.1 c0,1.7-1.8,3-3.9,3s-3.9-1.4-3.9-3c0-1.7,1.8-3,3.9-3S101.4,80.4,101.4,82.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8084BC",
  d: "M100.4,90.8c0,2.5,2.2,4.5,4.9,4.5s4.9-2,4.9-4.5s-2.2-4.5-4.9-4.5S100.4,88.3,100.4,90.8z M105.3,89.3 c1,0,1.9,0.7,1.9,1.5s-0.9,1.5-1.9,1.5s-1.9-0.7-1.9-1.5S104.3,89.3,105.3,89.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8084BC",
  d: "M57.9,56.7l6.5-1l-7.8,8.1c-0.5,0.5-0.6,1.2-0.2,1.7c0.3,0.5,0.8,0.8,1.3,0.8c0.1,0,0.2,0,0.3,0l10.9-1.9 c0.8-0.1,1.4-0.9,1.2-1.7s-0.9-1.4-1.7-1.2L62,62.6l7.7-8c0.4-0.5,0.5-1.2,0.3-1.7c-0.3-0.6-0.9-0.9-1.6-0.8l-10.9,1.6 c-0.8,0.1-1.4,0.9-1.3,1.7C56.3,56.3,57.1,56.8,57.9,56.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8084BC",
  d: "M69.5,60.2c0.1,0.8,0.9,1.4,1.7,1.3l4.5-0.7l-5.8,6c-0.5,0.5-0.6,1.2-0.2,1.7c0.3,0.5,0.8,0.8,1.3,0.8 c0.1,0,0.2,0,0.3,0l8.9-1.5c0.8-0.1,1.4-0.9,1.2-1.7s-0.9-1.4-1.7-1.2l-4.4,0.8l5.7-5.9c0.4-0.5,0.5-1.2,0.3-1.7 c-0.3-0.6-0.9-0.9-1.6-0.8l-8.9,1.3C69.9,58.6,69.4,59.4,69.5,60.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8084BC",
  d: "M83.7,67l1.1-0.2l-2.4,2.5c-0.5,0.5-0.6,1.2-0.2,1.7c0.3,0.5,0.8,0.8,1.3,0.8c0.1,0,0.2,0,0.3,0l5.4-0.9 c0.8-0.1,1.4-0.9,1.2-1.7s-0.9-1.4-1.7-1.2l-0.9,0.2l2.2-2.3c0.4-0.5,0.5-1.2,0.3-1.7c-0.3-0.6-0.9-0.9-1.6-0.8l-5.4,0.8 c-0.8,0.1-1.4,0.9-1.3,1.7C82.2,66.6,82.9,67.2,83.7,67z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8084BC",
  d: "M130.8,73.5c-0.5-0.2-1.2-0.1-1.6,0.2l-2.6,2.3c-0.3,0.3-0.5,0.6-0.5,1l-2.3,27.4c-0.3-0.6-0.6-1.1-0.9-1.6 c0.5-1,0.8-2.1,0.8-3.2c0-3.8-3.1-6.8-6.8-6.8c-3.5,0-6.3,2.6-6.8,6c-8.3-1.9-14.8-2.9-19.4-3c-0.2,0-0.5,0-0.7,0 c-3.9,0-10.4,0.9-17.1,2.2c0,0,0,0-0.1,0c-10.1,2.1-20.2,5.2-21.3,8.1c-0.3,0.9,0,1.8,0.7,2.4c0.7,0.6,1.4,1.2,2.1,1.7h-6.9 c-0.6,0-1.2,0.4-1.4,1l-5.3,16.2c-0.1,0.5-0.1,1,0.2,1.3c0.3,0.4,0.7,0.6,1.2,0.6h5.3c0.5,0,0.9-0.2,1.2-0.6l2.4-3h71l3.2,3.2 c0.3,0.3,0.7,0.4,1.1,0.4c0,0,0,0,0,0l3.8-0.1c0.8,0,1.5-0.7,1.5-1.5v-53C131.7,74.3,131.4,73.8,130.8,73.5z M90.7,98.9 c0.2,0,0.4,0,0.6,0l-3.9,5.5l-9.3-4.3c4.4-0.8,8.7-1.3,12-1.3C90.3,98.9,90.5,98.9,90.7,98.9z M128.7,126.5l-1.7,0l-3.2-3.2 c-0.3-0.3-0.7-0.4-1.1-0.4H50.4c-0.5,0-0.9,0.2-1.2,0.6l-2.4,3h-2.5l4.3-13.2h10.7c0.7,0,1.3-0.5,1.5-1.1c0.2-0.7-0.1-1.4-0.7-1.7 c0,0-2.2-1.2-5.1-3.6c2.2-1.5,9.9-3.9,18.1-5.7l14.2,6.5c0.2,0.1,0.4,0.1,0.6,0.1c0.5,0,0.9-0.2,1.2-0.6l5.7-8 c4.4,0.5,10,1.5,16.5,3c0.1,0.4,0.3,0.7,0.6,1c0,0,3,2.2,4.6,7.3c0.1,0.4,0,0.6-0.1,0.8c-3.6,4.3-32.1,2.7-49.2,0.6 c-0.8-0.1-1.6,0.5-1.7,1.3s0.5,1.6,1.3,1.7c4.4,0.5,18.9,2.1,31.5,2.1c9.5,0,17.9-0.9,20.4-3.8c0.9-1,1.1-2.3,0.7-3.6 c-1.9-6-5.5-8.7-5.6-8.8c-0.1-0.1-0.3-0.2-0.4-0.2c0,0,0,0,0-0.1c-0.1-0.3-0.1-0.5-0.1-0.7c0-2.1,1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8 c0,1.1-0.5,1.9-0.9,2.4c-0.3,0.4-0.4,0.9-0.3,1.4c0.1,0.4,0.5,0.8,0.9,0.9c0.7,0.8,2,5,2.7,9.1c0.1,0.7,0.8,1.2,1.5,1.2 c0.8,0,1.4-0.6,1.4-1.4l2.6-31.3V126.5z"
}));

function SvgIconBestBedTimeCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 175.7 175.7",
    enableBackground: "new 0 0 175.7 175.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBestBedTimeCircle);
export default __webpack_public_path__ + "static/media/icon-BestBedTime-circle.8e125573.svg";
export { ForwardRef as ReactComponent };